import { NavLink } from "./NavLink";
import { socialProfiles } from "../siteContent";

export function Footer({ navigate }) {
  return (
    <footer className="footer">
      <div>
        <strong>Aspirant CSS</strong>
        <p>A calm CSS, PMS and MPT study room for Pakistan.</p>
        <p className="footer-disclaimer">
          An independent DevZona Labs product. Not affiliated with FPSC or any government institution.
        </p>
        <a
          className="footer-instagram"
          href={socialProfiles.instagram.url}
          target="_blank"
          rel="me noreferrer"
          aria-label="Follow Aspirant CSS on Instagram"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <rect x="3" y="3" width="18" height="18" rx="5" />
            <circle cx="12" cy="12" r="4" />
            <circle cx="17.5" cy="6.5" r="1" className="instagram-dot" />
          </svg>
          <span>
            Follow on Instagram
            <strong>{socialProfiles.instagram.handle}</strong>
          </span>
        </a>
      </div>
      <div className="footer-links">
        <NavLink to="/css-2027" className="footer-link" onNavigate={navigate}>
          Start here
        </NavLink>
        <NavLink to="/css-subjects" className="footer-link" onNavigate={navigate}>
          Subjects
        </NavLink>
        <NavLink to="/css-syllabus" className="footer-link" onNavigate={navigate}>
          CSS syllabus
        </NavLink>
        <NavLink to="/css-past-papers" className="footer-link" onNavigate={navigate}>
          Solved papers
        </NavLink>
        <NavLink to="/pms-preparation" className="footer-link" onNavigate={navigate}>
          PMS preparation
        </NavLink>
        <NavLink to="/mpt-past-papers" className="footer-link" onNavigate={navigate}>
          MPT past papers
        </NavLink>
        <NavLink to="/exam-calendar" className="footer-link" onNavigate={navigate}>
          Calendar
        </NavLink>
        <NavLink to="/blogs" className="footer-link" onNavigate={navigate}>
          CSS guides
        </NavLink>
        <NavLink to="/about" className="footer-link" onNavigate={navigate}>
          About
        </NavLink>
        <NavLink to="/css-vista" className="footer-link" onNavigate={navigate}>
          CSS Vista
        </NavLink>
        <NavLink to="/contact" className="footer-link" onNavigate={navigate}>
          Contact
        </NavLink>
        <NavLink to="/aspirant-app" className="footer-link" onNavigate={navigate}>
          Mobile app
        </NavLink>
        <NavLink to="/privacy-policy" className="footer-link" onNavigate={navigate}>
          Privacy
        </NavLink>
        <NavLink to="/terms-of-use" className="footer-link" onNavigate={navigate}>
          Terms
        </NavLink>
      </div>
    </footer>
  );
}
